/**
 * Created by Bart Decorte
 * Date: 2019-08-28
 * Time: 18:36
 */

// .js-entry child of $form, $form, '.js-matrix'
function isDirectChildOfClass($child, $candidateParent, selector) {
  const $parent = $child.parents(selector).first();
  return $parent.parents().length == $candidateParent.parents().length;
}

export { isDirectChildOfClass };



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/dom_helper.js